import React from "react";
import audienceNextArrow from "../../assets/images/webp/other/audience-next-arrow.webp";
import { AUDIENCE_LIST } from "../../utils/other-component";
import Icons from "../common/components/Icons";
import BlueTag from "../common/ui/BlueTag";
import Heading from "../common/ui/Heading";
import Paragraph from "../common/ui/Paragraph";

const Audience = () => {
  return (
    <>
      <div className="py-[140px] max-xl:py-[120px] max-lg:py-24 max-md:py-20 max-sm:py-10">
        <div className="px-4 bg-[#EAF3EE]">
          <div className="py-[100px] max-lg:py-20 max-md:py-14 max-sm:py-10">
            <div className="flex items-center justify-center flex-col">
              <BlueTag center>Audience</BlueTag>
              <Heading> Why Audiences Love Him</Heading>
              <Paragraph className="max-w-[548px] mx-auto text-center pt-1">
                {" "}
                Because he speaks from experience, not theory. Because he’s
                relatable, humble, and powerfully real. Because he shows people
                what’s possible – regardless of language, location, or luck.
              </Paragraph>
            </div>
            <div className="max-w-[1140px] w-full mx-auto h-[426px] flex flex-wrap max-lg:justify-center max-lg:h-full max-lg:!gap-6 relative mt-[50px] transition-all ease-linear duration-300 hover:scale-100">
              <img
                src={audienceNextArrow}
                alt="arrow"
                width={272}
                height={83}
                className="absolute top-[-74px] left-[18%] z-10 max-lg:hidden"
              />
              <img
                src={audienceNextArrow}
                alt="arrow"
                width={272}
                height={83}
                className="absolute top-[-24px] right-[18%] z-10 max-lg:hidden"
              />
              {AUDIENCE_LIST.map((obj, i) => (
                <div
                  key={i}
                  className={`projects-box-bg lg:hidden w-full max-w-[364px] max-xl:max-w-[300px] p-[1px] h-[241px] flex items-center justify-center flex-col shadow-[0px_4px_17.7px_0px_#0000001A] rounded-2xl `}
                >
                  <div className="w-full bg-white h-full flex items-center justify-center flex-col rounded-2xl">
                    <Icons icon={obj.icon} />
                    <h3 className="text-[#001A3D] leading-[130%] text-[28px] text-center mx-auto max-w-[324px] ff-jakarta font-bold max-md:text-2xl max-sm:text-xl">
                      {obj.name}
                    </h3>
                  </div>
                </div>
              ))}
              {AUDIENCE_LIST.map((obj, i) => (
                <div
                  key={i}
                  className={`projects-box-bg max-lg:hidden w-full max-w-[364px] max-xl:max-w-[300px] p-[1px] h-[241px] flex items-center justify-center flex-col shadow-[0px_4px_17.7px_0px_#0000001A] rounded-2xl absolute ${
                    i === 0
                      ? "top-0 left-0"
                      : i === 1
                      ? "top-[42%] left-1/2 -translate-x-1/2 -translate-y-1/2"
                      : i === 2
                      ? "bottom-[20%] right-0"
                      : ""
                  }`}
                >
                  <div className="w-full bg-white h-full flex items-center justify-center flex-col rounded-2xl">
                    <Icons icon={obj.icon} />
                    <h3 className="text-[#001A3D] leading-[130%] text-[28px] text-center mx-auto max-w-[324px] ff-jakarta font-bold max-md:text-2xl max-sm:text-xl">
                      {obj.name}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Audience;
